import React from 'react';
import { Navigate } from 'react-router-dom';
import { appPath } from '../../routes/paths';
import { usePermission } from './PermissionsContext';

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission, children }) => {
  const allowed = usePermission(permission);

  if (!allowed) {
    return <Navigate to={appPath('/unauthorized')} replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
